<template>
  <section class="sitemap">
    <AccesskeyLink
      id="mainContent"
      class="accesskey-c"
      accesskey="C"
      title=":::主要內容顯示區"
    />
    <ArticleSitemap />
  </section>
</template>
<script>
import ArticleSitemap from "@/components/article/ArticleSitemap";
import { getArticleString } from "@/config/articleString";
import { mapGetters } from "vuex";
import AccesskeyLink from "@/components/a11y/AccesskeyLink.vue";

export default {
  name: "Sitemap",
  metaInfo() {
    return {
      title: "網站導覽",
      meta: [
        {
          vmid: "og:url",
          property: "og:url",
          content: this.productionWholeReference,
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "臺南宗教藝術-網站導覽",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: "臺南宗教藝術-網站導覽",
        },
      ],
    };
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["productionHostname"]),
    articleTitle() {
      return getArticleString("sitemap", "headline");
    },
    productionWholeReference() {
      return `${this.productionHostname}${window.location.pathname}${window.location.search}`;
    },
  },
  components: {
    ArticleSitemap,
    AccesskeyLink,
  },
};
</script>
<style lang="scss" scoped>
.sitemap {
  margin-top: 50px;
}
</style>
